'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareCredentials = exports.checkCredentials = undefined;

var _credentials = require('../constants/credentials.constants');

var _credentials2 = _interopRequireDefault(_credentials);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * @description :: Checking if the passed in credential is valid
 * @param {String} credential :: The credential to check
 * @return {String} :: credential or null if invalid
 */


var checkCredentials = exports.checkCredentials = function checkCredentials(credential) {
  if (!_credentials2.default.includes(credential)) {
    console.warn('"' + credential + '" is not a proper credential value. It should be one of: [' + _credentials2.default + ']');
    return null;
  }

  return credential;
};
/**
 * @description :: Preparing the credentials for the fetch execution
 * @param {String} profileCredentials :: Credentials that were set in the profile
 * @param {String} credentials :: Credentials that were set in the individual call
 * @return {String} :: Valid credentials or null
 */
// Constants


var prepareCredentials = exports.prepareCredentials = function prepareCredentials(profileCredentials, credentials) {
  if (credentials) return checkCredentials(credentials);
  if (profileCredentials) return checkCredentials(profileCredentials);
  return null;
};